import {atom} from "recoil";
import keys from "configs/atoms";

const errMsgAtom = atom(({
    key: keys.Common.ErrPopup,
    default: { msg: "", isShow: false } 
}));

export default errMsgAtom;